var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon1Way01 = function SvgIcon1Way01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 107.89,
    y1: 5.93,
    x2: 12.91,
    y2: 78.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.92,61.31c-1.15,0-2.08.93-2.08,2.08h0v14.39c0,.28-.04.56-.12.83l-23.45-26.46c-.76-.86-2.08-.94-2.94-.18-.86.76-.94,2.08-.18,2.94l22.89,25.83H7.97l22.89-25.83c.76-.86.68-2.18-.18-2.94-.86-.76-2.18-.68-2.94.18l-23.45,26.46c-.08-.27-.12-.55-.12-.83V28.92l37.33,25.72c5.13,3.51,11.88,3.51,17.01,0l37.33-25.72v8.66c0,1.15.93,2.08,2.08,2.08s2.08-.93,2.08-2.08v-15.36c0-3.94-3.2-7.13-7.13-7.13H7.13c-3.94,0-7.13,3.2-7.13,7.13v55.57c0,3.94,3.2,7.13,7.13,7.13h85.73c3.94,0,7.13-3.2,7.13-7.13v-14.39c0-1.15-.93-2.08-2.08-2.08h0ZM7.13,19.25h85.73c1.64,0,2.96,1.33,2.97,2.97v1.64l-39.69,27.35c-3.7,2.53-8.58,2.53-12.28,0L4.17,23.86v-1.64c0-1.64,1.33-2.96,2.97-2.97Z"
  })));
};
export default SvgIcon1Way01;